import { createHttpLink } from '@apollo/client';

import { getEnvConfig } from 'config/environment';

const apiUrl = getEnvConfig().REACT_APP_GQL_URL;
const suspensionApiUrl = getEnvConfig().REACT_APP_SUSPENSION_SERVICE_URL;
const rankingsApiUrl = getEnvConfig().REACT_APP_RANKINGS_SERVICE_URL;

export const httpLink = createHttpLink({
  uri: apiUrl,
  headers: { 'x-clubspark-root-provider-id': (window as any).__provider__ },
});

export const suspensionLink = createHttpLink({
  uri: suspensionApiUrl,
});

export const rankingsLink = createHttpLink({
  uri: rankingsApiUrl,
});
